export const formConst = {
  accounttypes: {
    admin: [
      {
        value: 100,
        label: "Administrator",
      },
      {
        value: 110,
        label: "Pccwglobal Sales",
      },
      {
        value: 120,
        label: "Pccwglobal Product",
      },
      {
        value: 130,
        label: "Pccwglobal Operation",
      },
      {
        value: 140,
        label: "Pccwglobal Billing",
      },
      {
        value: 200,
        label: "Master Account",
      },
      // {
      //   value: 200,
      //   label: "Master",
      // }
    ],
    pccwglobal_sub: [
      {
        value: 110,
        label: "Pccwglobal Sales",
      },
      {
        value: 120,
        label: "Pccwglobal Product",
      },
      {
        value: 130,
        label: "Pccwglobal Operation",
      },
      {
        value: 140,
        label: "Pccwglobal Billing",
      },
      // {
      //   value: 200,
      //   label: "Master",
      // }
    ],
    master: [{
      value: 210,
      label: "Sub-account-sales",
    },
    {
      value: 220,
      label: "Sub-account-product",
    },
    {
      value: 230,
      label: "Sub-account-operation",
    },
    {
      value: 240,
      label: "Sub-account-billing",
    }]
  },
  functionalities: {
    pccwglobal:
      [
        {
          value: 110,
          label: "Account management",
        },
        {
          value: 120,
          label: "Customer management",
        },
        {
          value: 200,
          label: "Orders management",
        },
        {
          value: 210,
          label: "Service Number Types offered in GIS management",
        },
        {
          value: 240,
          label: "Third Party Vendors Management",
        },
        {
          value: 1010,
          label: "Permission administration",
        },
        {
          value: 1020,
          label: "Notification types administration",
        },
        {
          value: 800,
          label: "Support Management",
        },
        // {
        //   value: 900,
        //   label: "Report Management",
        // },
      ],
    customer: [
      {
        value: 110,
        label: "Account management",
      },
      {
        value: 120,
        label: "Customer management",
      },
      {
        value: 200,
        label: "Orders management",

      },
      {
        value: 1010,
        label: "Permission administration",
      },
      {
        value: 1020,
        label: "Notification types administration",
      },
      // {
      //   value: 800,
      //   label: "Support Management",
      // },
      // {
      //   value: 900,
      //   label: "Report Management",
      // },
    ]
  }
}
